import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';

/**
 * Dialog that prompts the user to refresh the current page.
 * On confirmation it closes all open dialogs and forces a route reload without a full browser refresh.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'qiasphere-generic-dialog',
  templateUrl: './refresh-page-dialog.component.html',
  styleUrls: ['./refresh-page-dialog.component.scss'],
  imports: [MatDialogTitle, MatIcon, MatDialogContent, MatDialogActions, MatButton, MatDialogClose]
})
export class RefreshPageDialogComponent {
  private readonly router = inject(Router);
  private readonly dialogs = inject(MatDialog);
  data = inject<{
    icon: string;
    title: string;
    message: string;
    confirmButtonText: string;
  }>(MAT_DIALOG_DATA);

  refresh(): void {
    this.dialogs.closeAll();
    const prevConfiguration = this.router.routeReuseStrategy.shouldReuseRoute;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigate([this.router.url]).then(() => {
      this.router.routeReuseStrategy.shouldReuseRoute = prevConfiguration;
    });
  }
}
